var map = {
	"./1.jpg": "7520",
	"./10.jpg": "bed1",
	"./11.jpg": "38bc",
	"./12.jpg": "311e",
	"./13.jpg": "7986",
	"./14.jpg": "79cb",
	"./15.jpg": "4fd9",
	"./16.jpg": "54b6",
	"./17.jpg": "3aab",
	"./18.jpg": "7bd7",
	"./19.jpg": "9dbc",
	"./2.jpg": "726c",
	"./20.jpg": "2e8f",
	"./21.jpg": "dc7e",
	"./22.jpg": "2ebc",
	"./23.jpg": "e9d4",
	"./24.jpg": "37eb",
	"./3.jpg": "5c5c",
	"./4.jpg": "86c4",
	"./5.jpg": "ecec",
	"./6.jpg": "2b15",
	"./7.jpg": "ad4a",
	"./8.jpg": "d4b2",
	"./9.jpg": "ea2a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e955";